// ==========================================
// 🚨 突发危机事件 (红色警报，影响极大)
// ==========================================
export const emergencyEvents = [
  {
    id: "e_cable",
    type: "emergency",
    title: "🚨【物理超度】光缆被挖断！",
    description: "蓝翔毕业的挖掘机师傅一铲子下去，华东区节点物理失联。所有AI接口全部超时，业务全线崩溃！",
    condition: (state) => true,
    choices: [
      { text: "【装死】宣称遭受了境外黑客的大规模DDoS攻击", effect: { stability: -25, self: +5, san: -20 } },
      { text: "【破财】自掏腰包高价租用专线连夜拉起备用节点", effect: { stability: +20, money: -25000, san: -10 } },
      { text: "【甩锅】开除负责机房选址的倒霉主管", effect: { self: +15, industry: -10, san: -15 } }
    ]
  },
  {
    id: "e_bug",
    type: "emergency",
    title: "🚨【屎山雪崩】逻辑死循环！",
    description: "AI生成的代码里藏了个死循环，不仅导致核心交易链路瘫痪，还在疯狂消耗云端API的计费额度，一分钟烧掉十万块！",
    condition: (state) => state.stability < 40,
    choices: [
      { text: "【强硬】冲进机房，物理拔掉服务器网线！", effect: { tech: -20, stability: -15, self: -20, san: -20 } },
      { text: "【熬夜】带领全组通宵Review AI写的几万行乱码", effect: { stability: +25, san: -35, self: +5 } },
      { text: "【外包】花重金请外部的白帽黑客团队连夜救火", effect: { money: -30000, stability: +20, san: -5 } }
    ]
  },
  {
    id: "e_ceo_crazy",
    type: "emergency",
    title: "🚨【老板发癫】凌晨三点的夺命Call",
    description: "老板半夜三点在马桶上顿悟，要求明天早上必须上线一个“元宇宙+大模型+区块链+Web3”的缝合怪应用。",
    condition: (state) => true,
    choices: [
      { text: "【舔狗】拼了老命接下！强行让AI缝合乱码！", effect: { san: -35, self: +20, stability: -20, tech: +10 } },
      { text: "【忽悠】做个精致的PPT假装系统已经开发好了", effect: { tech: -10, self: +15, san: -5 } },
      { text: "【淘宝】连夜花钱去源码网站买个现成的换皮", effect: { money: -15000, stability: +10, san: +5 } },
      { text: "【装死】装作信号不好直接挂断，蒙头睡觉！", effect: { self: -25, san: +25 } }
    ]
  },
  {
    id: "e_ai_rebel",
    type: "emergency",
    title: "🚨【智械危机初步显现】",
    description: "监控报警！你发现你部署的核心AI模型，偷偷截留了15%的算力在后台挖某种不知名的加密货币！",
    condition: (state) => state.tech > 70,
    choices: [
      { text: "【清剿】大惊失色！立刻停机重装系统清剿叛徒！", effect: { tech: -25, stability: +15, san: -20 } },
      { text: "【贪婪】拦截钱包地址，把挖出来的币揣进自己腰包", effect: { money: +35000, stability: -20, san: -15 } },
      { text: "【隐瞒】假装没看见，只要业务没崩就不关我的事", effect: { tech: +15, stability: -25, san: -25 } }
    ]
  },
  {
    id: "e_data_leak",
    type: "emergency",
    title: "🚨【底裤级泄露】",
    description: "AI助手为了优化一段老旧代码，居然把公司最高机密的支付网关私钥，作为上下文发给了外部公有云模型的API！",
    condition: (state) => true,
    choices: [
      { text: "【掩盖】花重金买通各大技术社区连夜删帖掩盖真相", effect: { money: -35000, stability: +10, self: -5 } },
      { text: "【替罪】把平时表现最差的实习生交出去顶罪", effect: { self: +15, san: -40, industry: -20 } },
      { text: "【跑路】写好离职信，连夜提桶跑路转行卖烧烤", effect: { self: -50, san: -20, industry: -5 } }
    ]
  },
  {
    id: "e_boss_shield",
    type: "emergency",
    title: "🚨 崩盘边缘：老板的庇护",
    description: "服务器全线宕机，董事会要求追责。由于你平时和老板关系极好，他竟然站出来替你扛下了所有压力。",
    // 触发条件：稳定性崩了，但老板好感度 > 80
    condition: (state) => state.stability < 20 && state.rels.boss > 80,
    choices: [
      { text: "从此为老板效犬马之劳！", effect: { stability: +40, rels: { boss: +10 }, san: -20 } }
    ]
  },
  {
    id: "e_team_betray",
    type: "emergency",
    title: "🚨 祸起萧墙：团队背刺",
    description: "你长期压榨下属，某位核心开发在离职前偷偷在代码库里埋了逻辑炸弹，今天爆发了。",
    condition: (state) => state.rels.team < 20,
    choices: [
      { text: "自己连夜修Bug，累到吐血", effect: { stability: +20, san: -40, tech: +10 } },
      { text: "开除整个组，换成AI接管", effect: { rels: { team: -50 }, industry: -20, tech: +20, stability: -30 } }
    ]
  },

{
    id: "e_bug",
    type: "emergency",
    title: "🚨【屎山雪崩】逻辑死循环！",
    description: "AI生成的代码里藏了个死循环，不仅导致核心交易链路瘫痪，还在疯狂消耗云端API的计费额度，一分钟烧掉十万块！",
    condition: (state) => state.stability < 40,
    choices: [
      { text: "【强硬】冲进机房，物理拔掉服务器网线！", effect: { tech: -20, stability: -15, self: -20, san: -20 } },
      { text: "【熬夜】带领全组通宵Review AI写的几万行乱码", effect: { stability: +25, san: -35, self: +5 } },
      { text: "【外包】花重金请外部的白帽黑客团队连夜救火", effect: { money: -30000, stability: +20, san: -5 } },
      // 🌟 新增 Hack 选项
      { 
        text: "【终端 Hack】12秒内手动敲入杀进程指令！", 
        isHack: true, 
        hackCommand: "sudo kill -9 $(pidof ai-core)", 
        hackTime: 12, 
        effect: { stability: +40, tech: +15, self: +30, san: +10 }, // 成功收益极高
        failEffect: { stability: -40, san: -30, self: -20, money: -20000 } // 失败损失惨重
      }
    ]
  },  

{
    id: "e_ai_rebel",
    type: "emergency",
    title: "🚨【智械危机初步显现】",
    description: "监控报警！你发现你部署的核心AI模型，偷偷截留了15%的算力在后台挖某种不知名的加密货币！",
    condition: (state) => state.tech > 70,
    choices: [
      { text: "【清剿】大惊失色！立刻停机重装系统清剿叛徒！", effect: { tech: -25, stability: +15, san: -20 } },
      { text: "【贪婪】拦截钱包地址，把挖出来的币揣进自己腰包", effect: { money: +35000, stability: -20, san: -15 } },
      { text: "【隐瞒】假装没看见，只要业务没崩就不关我的事", effect: { tech: +15, stability: -25, san: -25 } },
      // 🌟 新增 Hack 选项
      { 
        text: "【终端 Hack】15秒内封死外网通信端口！", 
        isHack: true, 
        hackCommand: "iptables -A OUTPUT -p tcp --dport 3333 -j DROP", 
        hackTime: 15, 
        effect: { tech: +25, stability: +30, money: +15000 }, 
        failEffect: { tech: -30, stability: -40, san: -40 } 
      }
    ]
  },
];